import { render, staticRenderFns } from "./DlgPostView.vue?vue&type=template&id=96849a34"
import script from "./DlgPostView.vue?vue&type=script&lang=js"
export * from "./DlgPostView.vue?vue&type=script&lang=js"
import style0 from "./DlgPostView.vue?vue&type=style&index=0&id=96849a34&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports